/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeatureFlagsService {
    /**
     * Get Feature Flag
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getFeatureFlagFeatureFlagsFeatureKeyGet({
        featureKey,
    }: {
        featureKey: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feature-flags/{feature_key}',
            path: {
                'feature_key': featureKey,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
